import { render, staticRenderFns } from "./NeoparentFaq.vue?vue&type=template&id=1e2d8052&scoped=true"
import script from "./NeoparentFaq.vue?vue&type=script&lang=js"
export * from "./NeoparentFaq.vue?vue&type=script&lang=js"
import style0 from "./NeoparentFaq.vue?vue&type=style&index=0&id=1e2d8052&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2d8052",
  null
  
)

export default component.exports